import React, { useState, useEffect } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IconButton, Grid, Popover, Typography, Alert, TextField } from "@mui/material";
import { SuggestionContainer, Suggestion } from "./styles";

import { ExchangeRateDTO } from "../../../../models/exchange-rates";

import { State, Props } from "./interfaces";
import { useTranslation } from "react-i18next";

const ExchangeRateBookingsSuggestions = ({ exchangeRateSuggestions }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_travel_expense.exchange_rate_suggestion";

  const [state, setState] = useState<State>({
    error: "",
    open: false,
    anchorEl: null,
    exchangeRateSuggestions: exchangeRateSuggestions ?? [],
    xRateCopiedIdx: null,
  });

  useEffect(() => {
    setState((state) => ({
      ...state,
      exchangeRateSuggestions,
    }));
  }, [exchangeRateSuggestions]);

  useEffect(() => {
    !state.open &&
      setState((state) => ({
        ...state,
        xRateCopiedIdx: null,
      }));
  }, [state.open]);

  return (
    <>
      <IconButton
        onClick={(event) => {
          setState((state) => ({
            ...state,
            open: true,
            anchorEl: event.currentTarget,
          }));
        }}
        title={`${t(`${tRP}.title`)}`}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </IconButton>
      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={() => {
          setState((state) => ({ ...state, open: false }));
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            //   backgroundColor: "rgb(245, 245, 245)",
            alignItems: "flex-start",
            width: "500px",
          },
        }}
      >
        <Grid>
          <Typography>
            <b>{`${t(`${tRP}.title`)}`} : </b>
          </Typography>
          {state.exchangeRateSuggestions.length > 0 ? (
            state.exchangeRateSuggestions.map((xRate: ExchangeRateDTO, idx) => (
              <SuggestionContainer
                key={idx}
                onClick={() => {
                  navigator.clipboard.writeText(xRate.rate.toString());
                  setState((state) => ({
                    ...state,
                    xRateCopiedIdx: idx,
                  }));
                }}
              >
                <Suggestion isSelected={state.xRateCopiedIdx === idx}>{`${xRate.rate}`}</Suggestion>
                {state.xRateCopiedIdx === idx && <Alert severity={"info"}>Copied to clipboard</Alert>}
              </SuggestionContainer>
            ))
          ) : (
            <Typography>{`${t(`${tRP}.no_exchange_rate_warning`)}`}</Typography>
          )}
        </Grid>
      </Popover>
    </>
  );
};

export default ExchangeRateBookingsSuggestions;
